import { api } from "./api";

const API_URL = "/auth";

const login = async (credentials: {
  usernameOrEmail: string;
  password: string;
  captchaValue: string;
}) => {
  const response = await api.post(`${API_URL}/login`, credentials);
  // Optionally, store token or user data in localStorage or context
  return response.data;
};

const register = async (user: {
  name: string;
  username: string;
  email: string;
  password: string;
  confirmPassword?: string;
  captchaValue: string;
}) => {
  const response = await api.post(`${API_URL}/register`, {
    ...user,
    role: "user",
  });
  return response.data;
};

const logout = async () => {
  await api.post(`${API_URL}/logout`);
};

const getUserProfile = async () => {
  const token = localStorage.getItem("token");
  if (!token) return;
  const response = await api.get(`${API_URL}/profile`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

const verifyEmail = async (token: string) => {
  const response = await api.post(`${API_URL}/verify-email`, { token });
  return response.data;
};

const forgotPassword = async (email: string, captchaValue: string) => {
  const response = await api.post(`${API_URL}/forgot-password`, {
    email,
    captchaValue,
  });
  return response.data;
};

const resetPassword = async (token: string, password: string) => {
  const response = await api.post(`${API_URL}/reset-password`, {
    token,
    password,
  });
  return response.data;
};

const changePassword = async (currentPassword: string, newPassword: string) => {
  const response = await api.post(`${API_URL}/change-password`, {
    currentPassword,
    newPassword,
  });
  return response.data;
};

const resendVerificationEmail = async () => {
  const response = await api.post(`${API_URL}/resend-verification`);
  return response.data;
};

const authService = { login, register, logout, getUserProfile, verifyEmail, forgotPassword, resetPassword, changePassword, resendVerificationEmail };

export default authService;
